import { render } from "./MainCategories.vue?vue&type=template&id=19d0b84d&scoped=true"
import script from "./MainCategories.vue?vue&type=script&lang=js"
export * from "./MainCategories.vue?vue&type=script&lang=js"

import "./MainCategories.vue?vue&type=style&index=0&id=19d0b84d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d0b84d"]])

export default __exports__